import { Module } from 'vuex'
import { blankResponseArray } from '../constants'
import { RootState } from '../types'
import { actions } from './actions'
import { mutations } from './mutations'
import State from './types'
import { blankSearchFilters, blankUser } from './constants'
import { getters } from './getters'
import _ from 'lodash'

export const state: State = {
  error: false,
  page: 1,
  pageSize: 8,
  userList: blankResponseArray,
  preloaded: false,
  activeUser: blankUser,
  loading: false,
  errorMessage: '',
  searchFilters: _.cloneDeep(blankSearchFilters),
  aDUser: false,
}

const namespaced = true

export const users: Module<State, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters,
}
